import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  InvoicedReportOptionsResponse,
  InvoicedReportRequest,
  InvoicedReportResponse,
} from "../types/InvoicedReport";

const baseUrl = "/api/InvoicedReport";

export const getInvoicedReportOptions = async (
  addressSystemId: number,
  currentUserId: number,
): Promise<InvoicedReportOptionsResponse> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get<InvoicedReportOptionsResponse>(
    `${baseUrl}/options/${addressSystemId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { currentUserId },
    },
  );
  return response.data;
};

export const generateInvoicedReport = async (
  request: InvoicedReportRequest,
): Promise<InvoicedReportResponse> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post<InvoicedReportResponse>(
    `${baseUrl}/generate`,
    request,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
